var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.products && _vm.products.length)?_c('ProductCarousel',{staticClass:"recommended-products",attrs:{"data-external":"recommended-products","title":_vm.title,"products":_vm.products}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }